import { loadMarkdown } from "../../utils/api";
import { Status } from "../../models/Status";
import { createAction } from "../../models/Action";
import * as T from "./types";

export const loadMarkdownContent = (link, path) => async (dispatch) => {
  dispatch(createAction(T.MARK_DOWN_STATUS, Status.createLoading()));

  try {
    const res: any = await loadMarkdown(link, path);
    dispatch(createAction(T.MARK_DOWN_STATUS, Status.createSuccess()));
    // Change the title intentionally
    const data = res.replace("# nuScenes detection task", "# Instructions");
    const clean = data
      .replace("# nuScenes tracking task", "# Instructions")
      .replace(
        "# nuScenes lidar panoptic segmentation and tracking task",
        "# Instructions"
      )
      .replace("# nuScenes prediction task", "# Instructions")
      .replace("# nuScenes lidar segmentation task", "# Instructions");

    dispatch(createAction(T.MARK_DOWN_DATA, clean));
  } catch (e) {
    dispatch(createAction(T.MARK_DOWN_STATUS, Status.createFailed()));
  }
};
